import React, { useCallback, useEffect, useState } from "react";

import { KpiCard } from "../components/KpiCard";
import { api } from "../lib/api";
import { formatCurrency, formatPercent } from "../lib/format";

interface DashboardKpis {
  leads_ativos: number;
  mrr_em_negociacao: number;
  receita_nao_recorrente: number;
  taxa_conversao: number;
  fups_vencidos: number;
}

export function DashboardPage() {
  const [kpis, setKpis] = useState<DashboardKpis | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchKpis = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await api.get<DashboardKpis>("/dashboard/kpis/");
      setKpis(response.data);
    } catch {
      setError("Não foi possível carregar os indicadores.");
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchKpis();
  }, [fetchKpis]);

  return (
    <div className="p-8">
      <h1 className="text-xl font-semibold text-slate-800">Dashboard</h1>

      {isLoading && <p className="mt-6 text-sm text-slate-500">Carregando...</p>}

      {!isLoading && error && (
        <div className="mt-6 rounded-[10px] border border-border-subtle bg-surface p-4">
          <p className="text-sm text-red-600">{error}</p>
          <button
            type="button"
            onClick={fetchKpis}
            className="mt-3 rounded-[10px] bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary-dark"
          >
            Tentar novamente
          </button>
        </div>
      )}

      {!isLoading && !error && kpis && (
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <KpiCard label="Leads ativos" value={String(kpis.leads_ativos)} hero />
          <KpiCard
            label="MRR em negociação"
            value={formatCurrency(kpis.mrr_em_negociacao)}
          />
          <KpiCard
            label="Receita não recorrente"
            value={formatCurrency(kpis.receita_nao_recorrente)}
          />
          <KpiCard
            label="Taxa de conversão"
            value={formatPercent(kpis.taxa_conversao)}
          />
          <KpiCard
            label="FUPs vencidos"
            value={String(kpis.fups_vencidos)}
            warning={kpis.fups_vencidos > 0}
          />
        </div>
      )}
    </div>
  );
}
